export default async function ({store}) {
  await store.dispatch('pages/category-collections/hasEvents')
}
